import * as action from './action'

export const CommonAction = Object.assign({}, action);